import type { FC } from 'react'
import Icon from '../../Icon/Icon'
import Close from '../../../assets/icons/shrink.svg'
import { MapButton } from '../styles'
import { Variant } from '../../Button/Button'

const CloseControl: FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <MapButton data-testid="closeControl" onClick={onClose} variant={Variant.PrimaryInverted}>
      <Icon size={20}>
        <Close />
      </Icon>
      Sluiten
    </MapButton>
  )
}

export default CloseControl
